import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { volumeFeatureTags, volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-5 py-20 sm:px-8" data-id="element-245" data-mp="183vkkneh6vui">
      <div className="mx-auto w-full max-w-6xl" data-id="element-246" data-mp="185gafzpuhqm1">
        <Reveal data-id="element-247" data-mp="1c4yxp2552ds1">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl md:text-5xl" data-id="element-248" data-mp="1c4p3f2d29kgj">
            The <span className="text-cheer" data-id="element-249" data-mp="1zvul7n2kamth">6 Complete Volumes</span>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-250" data-mp="24tmf2mmroj0b">
          {volumes.map((volume, index) => <Reveal key={volume.tag} delay={index % 3 * 0.05} className="h-full" data-id="element-251" data-mp="1qwhdayu366av" data-mpi={index}>
              <article className="flex h-full flex-col rounded-card border border-navy/10 bg-white p-6 shadow-card transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-252" data-mp="1vrmvpnoa52u7">
                <span className="w-fit rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-navy" data-id="element-253" data-mp="kf2lii2k47vo">
                  {volume.tag}
                </span>
                <h3 className="mt-4 font-display text-xl font-extrabold leading-snug tracking-tight text-navy" data-id="element-254" data-mp="3ja561yydw70t">
                  {volume.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/65" data-id="element-255" data-mp="3t7j8uvrdwxan">
                  {volume.description}
                </p>
                <ul className="mt-auto space-y-2.5 pt-6" data-id="element-256" data-mp="b0lexln1090v">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-257" data-mp="61s7oayc1e95">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cheer" aria-hidden="true" data-id="element-258" data-mp="krptwlcpbtvp" />
                      <span className="text-sm leading-snug text-navy/80" data-id="element-259" data-mp="ts4h5q987j1u">{bullet}</span>
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>

        <Reveal delay={0.08} data-id="element-260" data-mp="wuinzf41jiar">
          <div className="mt-10 rounded-card border border-navy/10 bg-blush px-6 py-8" data-id="element-261" data-mp="wvajyr1jvi1k">
            <ul className="flex flex-wrap items-center justify-center gap-3" data-id="element-262" data-mp="11tltt1ruhsjs">
              {volumeFeatureTags.map(tag => <li key={tag} className="rounded-full bg-white px-4 py-2 text-xs font-semibold text-navy" data-id="element-263" data-mp="16pu3hzn9wtjk">
                  {tag}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}